import React, { useEffect, useState } from 'react';
import { Box, Flex, Text } from '@chakra-ui/react';
import TaskbarItem from './TaskbarItem';

export const Taskbar = ({ pJSON, windows, activeWindow, setActiveWindow }) => {
  const [time, setTime] = useState(new Date());
  useEffect(() => {
    setInterval(() => {
      setTime(new Date());
    }, 1000);
  }, []);
  return (
    <Box
      bg={'red.800'}
      w={'100vw'}
      h={30}
      position={'absolute'}
      bottom={0}
      fontFamily={"'Glass TTY VT220', monospace"}
    >
      <Flex float={'left'} gap={2}>
        <Text
          px={2}
          cursor={'not-allowed'}
          textTransform={'uppercase'}
          fontSize={24}
          color={'white'}
        >
          DEMOS v{pJSON.version}
        </Text>
        {windows.map((item) => {
          return (
            <TaskbarItem
              key={item.id}
              id={item.id}
              name={item.name}
              isActive={item.id === activeWindow}
              setActiveWindow={setActiveWindow}
            />
          );
        })}
      </Flex>
      <Flex
        float={'right'}
        gap={2}
        px={2}
        textTransform={'uppercase'}
        fontSize={24}
        color={'white'}
      >
        {time.toLocaleTimeString()}
      </Flex>
    </Box>
  );
};

export default Taskbar;
